<div class="language-flags" *ngIf="languages && languages.length >= 1; else noflags">
  <img *ngFor="let lang of languages" [src]="Utils.getFlagSrc(lang)" [alt]="Utils.getFlagName(lang)" [title]="Utils.getFlagName(lang)" [attr.aria-label]="Utils.getFlagName(lang)" class="flag-icon me-1"
    style="width: 20px; height: 15px;">
</div>

<ng-template #noflags class="language-flags">
  -
</ng-template>